import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import '@shui/core/sh-icon';

@Component({
    selector: 'app-number-input-cell',
    templateUrl: './number-input-cell.component.html',
    imports: [FormsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NumberInputCellComponent implements ICellRendererAngularComp {
    protected value: number | null = null;
    private params!: ICellRendererParams;

    public agInit(params: ICellRendererParams): void {
        this.params = params;
        this.value = params.value;
    }

    public refresh(params: ICellRendererParams): boolean {
        this.value = params.value;
        return true;
    }

    protected onValueChange(newValue: number | null): void {
        this.value = newValue;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.params.node.setDataValue(this.params.colDef!.field!, newValue);
    }

    protected increment(): void {
        this.onValueChange((this.value ?? 0) + 1);
    }

    protected decrement(): void {
        this.onValueChange((this.value ?? 0) - 1);
    }
}
